import React, { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { getWaitScrutinize } from '../../redux/actions/multiReview'
import ProjectStatusDataTable from '../dataTable/ProjectStatusDataTable'
import DashboradToggle from '../dashboard/DashboradToggle'

export default function ProjectStatusInProgress({ config, onSettingChange = () => {} }) {
  const [loading, setloading] = useState(false)
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  let history = useHistory()

  const mockSchema = {
    header: 'โครงการอยู่ระหว่างดำเนินการ',
    projectCodeText: 'รหัสโครงการ',
    projectNameText: 'ชื่อโครงการ',
    projectTypeText: 'ประเภทโครงการ',
    projectStatusText: 'สถานะ',
    projectEditVerText: 'แก้ไขล่าสุด',
    totalSize: 6,
    buttonFilterStatus: [
      {
        buttonText: 'อยู่ระหว่างทำข้อตกลง', // ชื่อปุ่ม
        countStatus: 2, //จำนวนสถานะ
        colorStatus: '#00BCD4', // สีปุ่ม
        status: '6', //สถานะ
      },
      {
        buttonText: 'ดำเนินการ',
        countStatus: 565,
        colorStatus: '#4CAF50',
        status: '7',
      },
      {
        buttonText: 'ระงับโครงการ',
        countStatus: 0,
        colorStatus: '#FBC02D',
        status: '8',
      },
      {
        buttonText: 'รอยุติโครงการ',
        countStatus: 1,
        colorStatus: '#FF9800',
        status: '9',
      },
      {
        buttonText: 'รอสิ้นสุดโครงการ',
        countStatus: 111,
        colorStatus: '#F57C00',
        status: '10',
      },
      {
        buttonText: 'รอยกเลิกโครงการ',
        countStatus: 20,
        colorStatus: '#FF5722',
        status: '11',
      },
    ],
    values: [
      {
        projectVersionId: 'BF188176-729A-4DD4-91C0-806A3E3F2692',
        code: '63-0001',
        type: { icon: 'building2', projectType: 'แผนงาน ' },
        projectName: 'สานต่อโครงการอารักข์ สร้างภูมิคุ้มกันตั้งแต่เยาว์วัย',
        colorstatus: { code: '#00BCD4', labal: 'อยู่ระหว่างทำข้อตกลง ' },
        status: 'กลั่นกรอง',
        date: 'เวอร์ชั่น 1.01 19 พ.ย. 2563 07:57 น.',
      },
      {
        projectVersionId: 'BF188176-729A-4DD4-91C0-806A3E3F2692',
        code: '63-0002',
        type: { icon: 'copy-o', projectType: 'ชุดโครงการ ' },
        projectName: 'เดินหน้าโครงการชุมชนจักรยานเพื่อสุขภาวะ ปี 3',
        colorstatus: { code: '#00BCD4', labal: 'อยู่ระหว่างทำข้อตกลง ' },
        status: 'สิ้นสุดโครงการ',
        date: 'เวอร์ชั่น 1.00 19 พ.ย. 2563 07:57 น.',
      },
      {
        projectVersionId: 'BF188176-729A-4DD4-91C0-806A3E3F2692',
        code: '63-0003',
        type: { icon: 'file-o', projectType: 'โครงการ ' },
        projectName: 'โครงการธนาคารเวลา',
        colorstatus: { code: '#00BCD4', labal: 'อยู่ระหว่างทำข้อตกลง ' },
        status: 'ยืนข้อเสนอ ',
        date: 'เวอร์ชั่น 1.00 19 พ.ย. 2563 07:57 น.',
      },
      {
        projectVersionId: 'BF188176-729A-4DD4-91C0-806A3E3F2692',
        code: '63-0004',
        type: { icon: 'file-o', projectType: 'โครงการ ' },
        projectName:
          'รร.พระยามนธาตุราชศรีพิจิตร์ จัดโครงการสื่อสร้างสรรค์อย่าปล่อยให้เด็กอ้วนรร.พระยามนธาตุราชศรีพิจิตร์ จัดโครงการสื่อสร้างสรรค์อย่าปล่อยให้เด็กอ้วนรร.พระยามนธาตุราชศรีพิจิตร์ จัดโครงการสื่อสร้างสรรค์อย่าปล่อยให้เด็กอ้วน',
        colorstatus: { code: '#4CAF50', labal: 'ดำเนินการ ' },
        status: 'กลั่นกรอง',
        date: 'เวอร์ชั่น 1.00 19 พ.ย. 2563 07:57 น.',
      },
      {
        projectVersionId: 'BF188176-729A-4DD4-91C0-806A3E3F2692',
        code: '63-0005',
        type: { icon: 'building2', projectType: 'แผนงาน ' },
        projectName: 'ประชุมโครงการพัฒนารูปแบบความร่วมมือเพื่อขับเคลื่อนสุขภาวะ',
        colorstatus: { code: '#4CAF50', labal: 'ดำเนินการ ' },
        status: 'ทำสัญญา',
        date: 'เวอร์ชั่น 1.00 19 พ.ย. 2563 07:57 น.',
      },
      {
        projectVersionId: 'BF188176-729A-4DD4-91C0-806A3E3F2692',
        code: '63-0006',
        type: { icon: 'building2', projectType: 'แผนงาน ' },
        projectName: "ประกวดนวัตกรรม 'กาย จิต ปัญญา สังคม'",
        colorstatus: { code: '#4CAF50', labal: 'ดำเนินการ ' },
        status: 'ทำสัญญา',
        date: 'เวอร์ชั่น 1.00 19 พ.ย. 2563 07:57 น.',
      },
    ],
  }

  useEffect(() => {
    handelGetSchemaDashboard()
  }, [])

  const handelGetSchemaDashboard = async () => {
    setIsLoading(true)
    // startLoading()
    try {
      setSchema(mockSchema)
    } catch (e) {
      setError({})
    }
    // doneLoading()
    setIsLoading(false)
  }

  const handleGetWaitScrutinize = async (pagesize, pagenumber) => {
    // startLoading()
    setloading(true)
    try {
      const response = await getWaitScrutinize(pagesize, pagenumber)
      // console.log('response getWaitScrutinize', response)
      if (response) {
        setSchema(response)
      }
    } catch (e) {
      console.log('e', e)
    }
    setloading(false)
    // doneLoading()
  }

  return (
    <>
      {schema && (
        <>
          {config && (
            <DashboradToggle
              onChange={onSettingChange}
              dashboradName={config.key}
              checked={config.show}
              style={{ marginTop: 20, marginBottom: -15 }}
            />
          )}
          <ProjectStatusDataTable
            schema={schema}
            pagination={true}
            onReload={handleGetWaitScrutinize}
            loading={loading}
          />
        </>
      )}
    </>
  )
}
